export type ConsentStatusResponse = {
  data: {
    has_consent: boolean;
    current_version: string;
  };
};

type CsrfResponse = {
  csrf_token: string;
};

async function csrfToken(): Promise<string> {
  const response = await fetch('/api/v1/auth/csrf', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`CSRF failed: ${response.status}`);
  }

  const body = (await response.json()) as CsrfResponse;

  if (!body.csrf_token) {
    throw new Error('CSRF token is missing');
  }

  return body.csrf_token;
}

export async function fetchConsentStatus(): Promise<ConsentStatusResponse> {
  const response = await fetch('/api/v1/me/consent', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Consent status failed: ${response.status}`);
  }

  return response.json() as Promise<ConsentStatusResponse>;
}

export async function recordConsent(): Promise<void> {
  const csrf = await csrfToken();
  const response = await fetch('/api/v1/me/consent', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-TOKEN': csrf,
    },
  });

  if (response.status !== 201) {
    throw new Error(`Consent store failed: ${response.status}`);
  }
}

export async function revokeConsent(): Promise<void> {
  const csrf = await csrfToken();
  const response = await fetch('/api/v1/me/consent', {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-TOKEN': csrf,
    },
  });

  if (!response.ok) {
    throw new Error(`Consent revoke failed: ${response.status}`);
  }
}
